import React, {Component} from 'react';
import ContentSlider from '../contentSlider/ContentSlider';
import Request from '../request';
import {IMAGE_URL} from '../constants';
import ReactHtmlParser from 'react-html-parser';
import './category.css';

class Category extends Component {
    state = {
        brand_id: this.props.brand_id,
        brand: this.props.brand,
        categoryList: []
    };
    componentWillMount() {
        this.getCategory();
    }
    componentWillReceiveProps(props){
        if(props.brand_id === 3) return false;
        this.setState({
            brand_id: props.brand_id,
            brand: props.brand
        }, () => {
            this.getCategory()
        });
    }
    getCategory(){
        Request.post("category_allWithParent", {operation_id: this.state.brand_id})
        .then(response=>{
            if(response.status === "error"){ console.log(response.data); return false; }
            this.setState({categoryList: response.data});
        })
        .catch(reason=>console.log(reason));
    }
    redirectToCatalog(url){
        window.open(url);
    }
    render() {

        return <div className="category">
            <div className="brandDetail">
                <div className=""><img alt="" src={IMAGE_URL+this.state.brand.image} /></div>
                {this.props.lang === "tr" && <div className="categoryBrandContent">{ReactHtmlParser(this.state.brand.content_tr)}</div>}
                {this.props.lang === "eng" && <div className="categoryBrandContent">{ReactHtmlParser(this.state.brand.content_eng)}</div>}
                <div className="categoryIndicator"></div>
                {this.props.lang === "tr" && <div className="categoryButton"><button onClick={()=>this.redirectToCatalog(this.state.brand.button_link_tr)}> {ReactHtmlParser(this.state.brand.button_text_tr)}</button></div>}
                {this.props.lang === "eng" && <div className="categoryButton"><button onClick={()=>this.redirectToCatalog(this.state.brand.button_link_eng)}>{ReactHtmlParser(this.state.brand.button_text_eng)}</button></div>}
            </div>
            <div className="categoryDetail">
                {
                    this.state.categoryList.length > 0 &&
                    <ContentSlider
                        type="category"
                        itemPerPage={this.props.itemPerPage}
                        lang={this.props.lang}
                        data={this.state.categoryList}
                        external={this.props.selectCategory.bind(this)}
                    />
                }
            </div>
        </div>;
    }
}

/*

<div className="contentArrow"><i className="fa fa-arrow-left"></i></div>
{
    this.state.categoryList.length > 0 &&
    this.state.categoryList.map((item, index) => {
        return <CategoryItem key={index}
                             selectCategory={()=>this.props.selectCategory.bind(this)}
                             detail={item} />
    })
}
<div className="contentArrow"><i className="fa fa-arrow-right"></i></div>


const CategoryItem = (props) => {
    const url = IMAGE_URL+props.detail.image;
    return (
        <div className="categoryItem">
            <div className="categoryImage">
                <img alt="" src={url} />
            </div>
            <div className="categoryTitle">{props.detail.title_tr}</div>
            <div className="categoryContent">{ReactHtmlParser(props.detail.content_tr)}</div>
            <div className="indicator"></div>
            <div className="">
                <button onClick={props.selectCategory(props.detail.category_id)}>{props.detail.button_text_tr}</button>
            </div>
        </div>
    );
};
 */
export default Category;